import React from "react";
import { useTranslation } from "react-i18next";

import { MarketSerialBatchState } from "@/const";
import { Awesome } from "@components/Helpers";
import { getAttachement, url_reverse } from "@components/Utils";

export default function MarketSerialBatchStateDisplay({ batch }) {
    const { t } = useTranslation();

    switch (batch.state) {
        case MarketSerialBatchState.NEW:
        case MarketSerialBatchState.TO_BAN:
            return <Awesome type="hourglass-half" color="orange" tooltip={t("Данные находятся на модерации")} />;
        case MarketSerialBatchState.APPROVED:
            return (
                <Awesome
                    type="hourglass-half"
                    color="orange"
                    tooltip={t("Ваш запрос обрабатывается. Обновите страницу немного позже")}
                />
            );
        case MarketSerialBatchState.REJECTED:
            return <Awesome type="thumbs-down" color="black" tooltip={batch.comment_moderator} />;
        case MarketSerialBatchState.DONE:
            return (
                <Awesome
                    type="file-excel-o"
                    color="green"
                    onClick={() =>
                        getAttachement(
                            url_reverse(
                                "api:game:serials:batch_list",
                                { game_id: batch.game_id },
                                { export_batch: batch.id }
                            )
                        )
                    }
                />
            );
        case MarketSerialBatchState.BANNED:
            return <Awesome type="ban" color="red" tooltip={batch.comment_ban} />;
        default:
            return null;
    }
}
